export default "__VITE_ASSET__DnrybUUB__"